export default __webpack_public_path__ + "static/media/1_2_hl.8e39331b.png";